var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLungs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#337a10",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500.001 500.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M304.616,166.29c-29.72,0-31.176-9.652-31.176-28.156V37.126c0-12.924-10.516-23.44-23.44-23.44 s-23.44,10.516-23.44,23.44v101.008c0,18.504-1.456,28.156-31.184,28.156c-2.16,0-3.976,1.748-3.976,3.908v39.068 c0,2.16,1.832,3.908,3.992,3.908c23.22,0,41.596-5.324,54.596-15.832c13.004,10.508,31.412,15.832,54.628,15.832 c2.16,0,3.984-1.748,3.984-3.908v-39.068C308.6,168.038,306.776,166.29,304.616,166.29z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M205.024,270.586c-2.752-24.696-5.588-50.244-5.588-74.996c0-62.82-6.876-146.332-66.276-146.332 C60.94,49.258,0.004,241.01,0.004,361.414c-0.028,3.8-0.472,93.38,24.06,118.108c4.472,4.504,9.568,6.792,15.156,6.792 c14.764,0,22.104-5.64,32.268-13.436c12.752-9.788,30.208-23.196,74.508-35.968C221.1,415.254,213.296,344.99,205.024,270.586z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M499.996,361.446c0-120.432-60.932-312.188-133.148-312.188c-59.408,0-66.272,83.512-66.272,146.332 c0,24.752-2.84,50.296-5.584,74.996c-8.272,74.404-16.084,144.668,59.028,166.324c44.292,12.772,61.752,26.18,74.5,35.96 c10.164,7.804,17.504,13.444,32.268,13.444c5.584,0,10.68-2.288,15.152-6.792C500.468,454.794,500.028,365.218,499.996,361.446z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLungs);
export default __webpack_public_path__ + "static/media/lungs.3416557898af4960ee8053f2ccebf75e.svg";
export { ForwardRef as ReactComponent };